import classnames from 'classnames';
import React from 'react';
import { Table } from 'react-bootstrap';
import { DjangoListResponse, InvitedUserEntity } from 'v2/models';
import styles from './myTeam.module.scss';

interface InvitedUserListProps {
  list: DjangoListResponse<InvitedUserEntity> | undefined;
  isLoading: boolean;
}

const InvitedUserList = ({ list, isLoading }: InvitedUserListProps) => {
  if (!isLoading && !list?.results.length) {
    return (
      <h5 className="text-primary-dark pt-5">
        You have no open invitations at this time.
      </h5>
    );
  }

  return (
    <Table>
      <thead>
        <tr>
          <th className={classnames('text-light4', styles.tableHeader)}>
            Email Address
          </th>
        </tr>
      </thead>
      <tbody>
        {list?.results.map((item) => (
          <tr key={item.id}>
            <td className={classnames('py-4', styles.boldText)}>
              {item.email}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default InvitedUserList;
